<div class="flex flex-col gap-2" [formGroup]="pharmacyForm()">
  <label class="text-[14px] font-[500] text-gray-700" i18n="@@pharmacyLocationLabel">اللوكيشن</label>

  <div class="flex items-center gap-2">
    <button
      type="button"
      (click)="openMap()"
      class="flex h-11 w-12 shrink-0 items-center justify-center rounded-[8px] border border-gray-300 bg-gray-50 text-gray-600 transition-colors hover:cursor-pointer hover:bg-gray-100 hover:text-black">
      <app-location-icon />
    </button>

    <div class="relative w-full">
      <input
        type="text"
        formControlName="pharmacyLocation"
        placeholder="ادخل اللوكيشن هنا"
        i18n-placeholder="@@pharmacyLocationPlaceholder"
        class="focus:borderTabsColor h-11 w-full rounded-[8px] border border-gray-300 bg-white py-2 text-[14px] text-gray-700 transition-colors outline-none placeholder:text-gray-400 hover:border-gray-400 ltr:pr-10 ltr:pl-4 rtl:pr-4 rtl:pl-10" />

      <div class="pointer-events-none absolute top-1/2 -translate-y-1/2 text-gray-400 ltr:right-3 rtl:left-3">
        <app-search-icon />
      </div>
    </div>
  </div>

  @if (pharmacyForm().get("pharmacyLocation")?.touched && pharmacyForm().get("pharmacyLocation")?.invalid) {
    <div class="textTabsColor text-sm">
      @if (pharmacyForm().get("pharmacyLocation")?.hasError("required")) {
        <span i18n="@@pharmacyLocationRequired">Pharmacy location is required.</span>
      }
      @if (
        pharmacyForm().get("pharmacyLocation")?.hasError("invalidUrl") ||
        pharmacyForm().get("pharmacyLocation")?.hasError("pattern")
      ) {
        <span i18n="@@pharmacyLocationInvalid">Please enter a valid location link.</span>
      }
      @if (pharmacyForm().get("pharmacyLocation")?.hasError("maxlength")) {
        <span i18n="@@pharmacyLocationMaxLen">Pharmacy location link cannot exceed 500 characters.</span>
      }
    </div>
  }

  @if (locationError() && !isMapOpen()) {
    <app-warning-message role="alert" [description]="locationError()!" />
  }
</div>

@if (isMapOpen()) {
  <div class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4" dir="ltr" (click)="closeMap()">
    <div
      class="flex w-full max-w-xl flex-col overflow-hidden rounded-xl bg-white shadow-2xl"
      (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between border-b border-gray-200 px-5 py-3" dir="rtl">
        <h3 class="text-base font-bold text-gray-800" i18n="@@selectLocationMap">حدد الموقع من الخريطة</h3>

        <div class="flex items-center gap-3">
          <button
            type="button"
            (click)="getUserCurrentLocation()"
            [disabled]="isLocating()"
            class="flex items-center gap-1.5 rounded-lg border border-gray-300 bg-gray-50 px-3 py-1 text-xs font-medium text-gray-700 hover:cursor-pointer hover:bg-gray-100 disabled:opacity-50">
            <app-current-location-icon />
            @if (isLocating()) {
              <span i18n="@@mapLocatingInProgress">Locating...</span>
            } @else {
              <span i18n="@@mapMyCurrentLocation">My current location</span>
            }
          </button>

          <button type="button" (click)="closeMap()" class="text-gray-500 hover:cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
              <path d="M0 0h32v32H0z" fill="none" />
              <path
                fill="currentColor"
                d="M17.414 16L24 9.414L22.586 8L16 14.586L9.414 8L8 9.414L14.586 16L8 22.586L9.414 24L16 17.414L22.586 24L24 22.586z" />
            </svg>
          </button>
        </div>
      </div>

      <div class="w-full bg-gray-50 p-3" style="min-height: 360px">
        @if (locationError()) {
          <div dir="auto">
            <app-warning-message role="alert" [description]="locationError()!" />
          </div>
        }
        <div
          #mapElement
          dir="ltr"
          style="
            width: 100% !important;
            height: 350px !important;
            min-height: 350px !important;
            display: block !important;
          "
          class="rounded-lg border border-gray-200"></div>
      </div>

      <div class="flex items-center justify-end gap-3 border-t border-gray-200 px-5 py-3" dir="rtl">
        <button
          type="button"
          (click)="closeMap()"
          class="rounded-lg border border-gray-300 px-5 py-1.5 text-xs font-medium text-gray-700 hover:cursor-pointer hover:bg-gray-50"
          i18n="@@cancel">
          إلغاء
        </button>
        <button
          type="button"
          (click)="confirmLocation()"
          [disabled]="selectedLat() === null"
          class="bgTabsColor bgHoverPrimaryColor rounded-lg px-5 py-1.5 text-xs font-medium text-white transition-colors hover:cursor-pointer disabled:cursor-not-allowed disabled:opacity-50"
          i18n="@@confirmLocation">
          تأكيد الموقع
        </button>
      </div>
    </div>
  </div>
}
